export default __webpack_public_path__ + "static/media/img-slider-cmbus-admin-4.b530ea9c.png";